import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Download, Mail } from 'lucide-react';
export function BlogFeatured() {
  return <section className="pt-16 pb-8 bg-white" data-id="element-14">
      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-15">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-12" data-id="element-16">
          {/* Main Featured Article (Left - 60%) */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="lg:col-span-3 group cursor-pointer" data-id="element-17">
            <div className="relative overflow-hidden rounded-2xl mb-8 aspect-[16/9] bg-slate-100" data-id="element-18">
              <img src="https://images.unsplash.com/photo-1551190822-a9333d879b1f?w=1600&h=900&fit=crop" alt="Gastroenterologist Salary Guide 2024" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-19" />
            </div>

            <div className="max-w-3xl" data-id="element-20">
              <div className="flex items-center gap-3 mb-4" data-id="element-21">
                <span className="inline-block px-2.5 py-0.5 text-xs font-medium uppercase tracking-wide rounded-full bg-slate-100 text-slate-600" style={{
                fontFamily: "'Poppins', sans-serif"
              }} data-id="element-22">
                  Salary Guides
                </span>
                <span className="text-slate-400 text-sm font-light" style={{
                fontFamily: "'Poppins', sans-serif"
              }} data-id="element-23">
                  Jan 24, 2024
                </span>
              </div>

              <h2 className="text-3xl md:text-4xl font-medium text-[#1a365d] mb-4 group-hover:text-[#c73e4c] transition-colors leading-tight" style={{
              fontFamily: "'Poppins', sans-serif"
            }} data-id="element-24">
                Gastroenterologist Salary Guide 2024
              </h2>

              <p className="text-lg text-slate-600 mb-6 leading-relaxed font-light" style={{
              fontFamily: "'Poppins', sans-serif"
            }} data-id="element-25">
                Comprehensive compensation data for gastroenterologists across
                different practice settings and regions. Discover the latest
                salary trends, regional variations, and factors that influence
                GI physician earnings in today's market.
              </p>

              <span className="inline-flex items-center text-[#1a365d] font-medium group-hover:translate-x-2 transition-transform duration-300" style={{
              fontFamily: "'Poppins', sans-serif"
            }} data-id="element-26">
                Read full guide <ArrowRight className="ml-2 w-4 h-4" data-id="element-27" />
              </span>
            </div>
          </motion.div>

          {/* Side Content (Right - 40%) */}
          <div className="lg:col-span-2 flex flex-col gap-6" data-id="element-28">
            <h3 className="text-sm font-medium text-slate-400 uppercase tracking-wider" style={{
            fontFamily: "'Poppins', sans-serif"
          }} data-id="element-29">
              Trending Resources
            </h3>

            {/* Resource 1 with Image */}
            <motion.a href="#" initial={{
            opacity: 0,
            x: 20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.1
          }} className="group flex gap-4" data-id="element-30">
              <div className="flex-shrink-0 w-24 h-24 rounded-lg overflow-hidden bg-slate-100" data-id="element-31">
                <img src="https://images.unsplash.com/photo-1450101499163-c8848c66ca85?w=200&h=200&fit=crop" alt="Credentialing Guide" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-32" />
              </div>
              <div className="flex-1 min-w-0" data-id="element-33">
                <h4 className="text-base font-medium text-[#1a365d] mb-1.5 group-hover:text-[#c73e4c] transition-colors leading-snug" style={{
                fontFamily: "'Poppins', sans-serif"
              }} data-id="element-34">
                  The Complete Guide to Locum Tenens Credentialing
                </h4>
                <p className="text-sm text-slate-500 mb-2 font-light line-clamp-2" style={{
                fontFamily: "'Poppins', sans-serif"
              }} data-id="element-35">
                  Navigate medical licensing and privileging with our
                  step-by-step guide.
                </p>
                <div className="flex items-center text-xs font-medium text-slate-400 group-hover:text-[#1a365d] transition-colors" style={{
                fontFamily: "'Poppins', sans-serif"
              }} data-id="element-36">
                  <ArrowRight className="w-3 h-3 mr-1.5" data-id="element-37" />
                  Read Article
                </div>
              </div>
            </motion.a>

            <div className="h-px bg-slate-100" data-id="element-38" />

            {/* Resource 2 with Image */}
            <motion.a href="#" initial={{
            opacity: 0,
            x: 20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.15
          }} className="group flex gap-4" data-id="element-39">
              <div className="flex-shrink-0 w-24 h-24 rounded-lg overflow-hidden bg-slate-100" data-id="element-40">
                <img src="https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=200&h=200&fit=crop" alt="Staffing Trends Report" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-41" />
              </div>
              <div className="flex-1 min-w-0" data-id="element-42">
                <h4 className="text-base font-medium text-[#1a365d] mb-1.5 group-hover:text-[#c73e4c] transition-colors leading-snug" style={{
                fontFamily: "'Poppins', sans-serif"
              }} data-id="element-43">
                  2024 Healthcare Staffing Trends Report
                </h4>
                <p className="text-sm text-slate-500 mb-2 font-light line-clamp-2" style={{
                fontFamily: "'Poppins', sans-serif"
              }} data-id="element-44">
                  Exclusive data on the shifting landscape of healthcare
                  employment.
                </p>
                <div className="flex items-center text-xs font-medium text-slate-400 group-hover:text-[#1a365d] transition-colors" style={{
                fontFamily: "'Poppins', sans-serif"
              }} data-id="element-45">
                  <ArrowRight className="w-3 h-3 mr-1.5" data-id="element-46" />
                  Read Article
                </div>
              </div>
            </motion.a>

            <div className="h-px bg-slate-100" data-id="element-47" />

            {/* Resource 3 with Image */}
            <motion.a href="#" initial={{
            opacity: 0,
            x: 20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.2
          }} className="group flex gap-4" data-id="element-48">
              <div className="flex-shrink-0 w-24 h-24 rounded-lg overflow-hidden bg-slate-100" data-id="element-49">
                <img src="https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?w=200&h=200&fit=crop" alt="First Assignment Tips" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-50" />
              </div>
              <div className="flex-1 min-w-0" data-id="element-51">
                <h4 className="text-base font-medium text-[#1a365d] mb-1.5 group-hover:text-[#c73e4c] transition-colors leading-snug" style={{
                fontFamily: "'Poppins', sans-serif"
              }} data-id="element-52">
                  Your First Locum Assignment: What to Expect
                </h4>
                <p className="text-sm text-slate-500 mb-2 font-light line-clamp-2" style={{
                fontFamily: "'Poppins', sans-serif"
              }} data-id="element-53">
                  Essential tips for a smooth transition into locum tenens work.
                </p>
                <div className="flex items-center text-xs font-medium text-slate-400 group-hover:text-[#1a365d] transition-colors" style={{
                fontFamily: "'Poppins', sans-serif"
              }} data-id="element-54">
                  <ArrowRight className="w-3 h-3 mr-1.5" data-id="element-55" />
                  Read Article
                </div>
              </div>
            </motion.a>

            {/* Elegant Newsletter - faster fade in, matching hero input style */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.1
          }} className="mt-auto bg-slate-50 rounded-xl p-6 border border-slate-100" data-id="element-56">
              <div className="flex items-center gap-3 mb-3" data-id="element-57">
                <div className="p-2 bg-[#DB9744]/10 rounded-lg" data-id="element-58">
                  <Mail className="w-4 h-4 text-[#DB9744]" data-id="element-59" />
                </div>
                <h4 className="text-lg font-medium text-[#1a365d]" style={{
                fontFamily: "'Poppins', sans-serif"
              }} data-id="element-60">
                  Weekly Insights
                </h4>
              </div>
              <p className="text-sm text-slate-600 mb-4 font-light" style={{
              fontFamily: "'Poppins', sans-serif"
            }} data-id="element-61">
                Join <span className="font-medium text-[#1e3a5f]" data-id="element-62">15,000</span>
                <span className="font-medium text-[#4a90c2]" data-id="element-63">+</span> healthcare
                professionals receiving our weekly digest.
              </p>
              {/* Email input matching hero style */}
              <div className="relative" data-id="element-64">
                <input type="email" placeholder="Email address" className="w-full px-5 py-3.5 pr-28 bg-white border-0 rounded-full text-gray-900 placeholder-slate-600 text-sm font-light focus:outline-none focus:ring-2 focus:ring-[#c75a4a] transition-all shadow-md" style={{
                fontFamily: "'Poppins', sans-serif"
              }} data-id="element-65" />
                <button className="absolute right-1 top-1/2 -translate-y-1/2 px-5 py-2.5 bg-[#c75a4a] hover:bg-[#a0483b] text-white text-sm font-medium rounded-full transition-colors whitespace-nowrap" style={{
                fontFamily: "'Poppins', sans-serif"
              }} data-id="element-66">
                  Subscribe
                </button>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </section>;
}